import { createAction } from '@reduxjs/toolkit'
import { ActionNames } from '_constants'

export const alertActions = {
    successMsg: (msg) => dispatch => {
        dispatch(alertActions.clear());
        dispatch(alertActions.success(msg));
        setTimeout(()=>{ dispatch(alertActions.clear())}, 5000);
    },
    warningMsg: (msg) => dispatch => {
        dispatch(alertActions.clear());
        dispatch(alertActions.warning(msg));
        setTimeout(()=>{ dispatch(alertActions.clear())}, 5000);
    },
    success: createAction(ActionNames.ALERT_SUCCESS),
    warning: createAction(ActionNames.ALERT_WARNING),
    error: createAction(ActionNames.ALERT_ERROR),
    clear: createAction(ActionNames.ALERT_CLEAR)
};

